export default {
      id: "icon-trainingtype-usage",
      viewBox: "0 0 48 32",
      url: __webpack_public_path__ + "icons.svg#icon-trainingtype",
      toString: function () {
        return this.url;
      }
    }